<template>
  <ul id="context-menu">
    <span class="close-button mdi mdi-close-circle mdi-24px" @click="closeContextMenu"></span>
    <!-- <ContextMenuItem>切り取り</ContextMenuItem>
    <ContextMenuItem>コピー</ContextMenuItem> -->
    <ContextMenuItem><p class="not-copy menu-icon" @click="openEdit"><span class="mdi mdi-playlist-edit" style="margin-right: 5px;"></span>編集</p></ContextMenuItem>
    <ContextMenuItem><p class="not-copy menu-icon" @click="openDelete"><span class="mdi mdi-delete" style="margin-right: 5px;"></span>削除</p></ContextMenuItem>
    <ContextMenuItem><p class="not-copy menu-icon" @click="startFlgSet"><span class="mdi mdi-flag" style="margin-right: 5px;"></span>開始設定</p></ContextMenuItem>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import ContextMenuItem from '@/components/ui/ContextMenuItem'
export default {
  name: 'ContextMenuScenario',
  components: {
    ContextMenuItem
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    openEdit () {
      console.debug('*** Start *** openEdit')
      this.$store.dispatch('chatbot/changeModalEditScenario')
      this.closeContextMenu()
      console.debug('*** End *** openEdit')
    },
    openDelete () {
      console.debug('*** Start *** openDelete')
      this.$store.dispatch('chatbot/changeModalDeleteScenario')
      this.closeContextMenu()
      console.debug('*** End *** openDelete')
    },
    startFlgSet () {
      console.debug('*** Start *** startFlgSet')
      this.$store.dispatch('chatbot/setStartFlgSet', this.user.companyID)
      this.closeContextMenu()
      console.debug('*** End *** startFlgSet')
    },
    closeContextMenu () {
      console.debug('*** Start *** closeContextMenu')
      document.getElementById('context-menu').classList.remove('active')
      console.debug('*** End *** closeContextMenu')
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#context-menu {
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  display: none;
  list-style: none;
  position: absolute;
  z-index: 2147483647;
  background-color: white;
  border: thin solid #00654C;
  border-bottom-width: 0px;
}
#context-menu.active {
  display: block;
}
.close-button {
  position: absolute;
  top: -27px;
  left: 107px;
}
.menu-icon {
  width: 100%;
  text-align: left;
  padding: 8px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Top/ContextMenuScenarioDemo.vue